import { render, staticRenderFns } from "./LiveSDK.vue?vue&type=template&id=dd3b5d1a&scoped=true&"
import script from "./LiveSDK.vue?vue&type=script&lang=ts&"
export * from "./LiveSDK.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3b5d1a",
  null
  
)

export default component.exports